import React, { useRef } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import Card from '../../../../../molecules/Card'
import InlineCardHeader from '../../../../../molecules/Card/InlineCardHeader'
import SydButton from '../../../../../commonDesign/Button'
import DatasourceDescription from '../shared/DatasourceDescription'
import DataSourceAttributes from '../shared/DatasourceAttributes'
import DatasourceActionsMenu from '../shared/DatasourceActionsMenu'
import EditApiInputsDialog from '../../dialogs/EditApiInputsDialog'
import EditApiOutputsDialog from '../../dialogs/EditApiOutputsDialog'
import ApiInputsTable from './ApiInputsTable'
import ApiOutputsAccordion from './ApiOutputsAccordion'

function ApiDetailsTab ({ datasource }) {
  const editInputsRef = useRef(null)
  const editOutputsRef = useRef(null)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader
            action={(
              <DatasourceActionsMenu datasource={datasource} />
            )}
          >
            Details
          </InlineCardHeader>
          <DataSourceAttributes datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader>Description</InlineCardHeader>
          <DatasourceDescription datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <InlineCardHeader
            action={
              <SydButton
                size='sm'
                icon='edit'
                onClick={() => editInputsRef.current.open(datasource)}
              >
                Edit
              </SydButton>
            }
          >
            API Inputs
          </InlineCardHeader>
          <ApiInputsTable apiInputs={datasource.apiInputs} />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <InlineCardHeader
            action={
              <SydButton
                size='sm'
                icon='edit'
                onClick={() => editOutputsRef.current.open(datasource)}
              >
                Edit
              </SydButton>
            }
          >
            API Outputs
          </InlineCardHeader>
          <ApiOutputsAccordion apiOutputs={datasource.apiOutputs} />
        </Card>
      </Grid>
      <EditApiInputsDialog ref={editInputsRef} />
      <EditApiOutputsDialog ref={editOutputsRef} />
    </Grid>
  )
}

ApiDetailsTab.propTypes = {
  datasource: PropTypes.any
}

export default ApiDetailsTab
